import { Router } from '@reach/router';
import { navigate } from 'gatsby';
import React from 'react';

import {
  Activate,
  Addresses,
  Login,
  Orders,
  PasswordRecover,
  PasswordReset,
  Register,
} from '../components/account';
import { MetaWebsite } from '../components/meta';
import PrivateRoute from '../components/private-route';
import { isBrowser } from '../utils';

const AccountPage = ({ location }) => {
  if (isBrowser && location.pathname.replace(/\/$/, '') === '/account') {
    navigate('/account/orders', {
      replace: true,
    });
  }

  return (
    <>
      <MetaWebsite pageTitle="Account" pathname={location.pathname} />
      <Router basepath="/account">
        <Activate path="/activate" />
        <Login path="/login" />
        <PasswordRecover path="/recover" />
        <PasswordReset path="/reset" />
        <Register path="/register" />
        <PrivateRoute path="/orders" component={Orders} location={location} />
        <PrivateRoute
          path="/addresses"
          component={Addresses}
          location={location}
        />
      </Router>
    </>
  );
};

export default AccountPage;
